<div class="drop-down-content-wrapper">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>
